// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_oa-5";
export var filledCircle = "_oa-4";
export var historyEntry = "_oa-3";
export var messageSideLeft = "_oa-1";
export var messageSideRight = "_oa-2";
export var orderTrackingCarouselWrapper = "_oa-6";
export var orderTrackingInfoContainer = "_oa-0";